export const GRID_SNAP = 15
export const VIEW_MOVE_STEP = 15
export const SCROLL_MAX = 3
export const SCROLL_MIN = 0.2
export const SCROLL_SPEED = 0.008
export const COPY_DATA_KEY = 'copyData'
